// Style for loading indicator
const style = document.createElement('style');
style.textContent = `
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  .loading-spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(style);

// Loading overlay functions
function showLoading() {
  const overlay = document.createElement('div');
  overlay.className = 'loading-overlay';
  overlay.innerHTML = '<div class="loading-spinner"></div>';
  document.body.appendChild(overlay);
}

function hideLoading() {
  const overlay = document.querySelector('.loading-overlay');
  if (overlay) overlay.remove();
}

/**
 * Get cart metadata items array (handles both old array format and new object format)
 * Volume discounts are now handled natively by Shopify - this only returns minQty data
 */
function getCartMetaItems() {
  if (typeof cartMeta === 'undefined') {
    return [];
  }
  // New format: cartMeta is an object with items array
  if (cartMeta && typeof cartMeta === 'object' && Array.isArray(cartMeta.items)) {
    return cartMeta.items;
  }
  // Legacy format: cartMeta was a direct array
  if (Array.isArray(cartMeta)) {
    return cartMeta;
  }
  return [];
}

async function createDraftOrder() {
  showLoading();
  
  try {
    // Get cart metadata items (handles both old and new format)
    const metaItems = getCartMetaItems();
    
    // Get current cart
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    // Check minimum quantities before proceeding
    const invalidItems = cart.items.filter(item => {
      const variantId = item.variant_id.toString();
      const itemMeta = metaItems.find(meta => meta.varId === variantId);
      
      const minQty = itemMeta?.minQty;
      if (!minQty) return false;
      
      const minQtyNum = parseInt(minQty, 10);
      const currentQty = parseInt(item.quantity, 10);
      
      return !isNaN(minQtyNum) && currentQty < minQtyNum;
    });

    if (invalidItems.length > 0) {
      const itemsList = invalidItems.map(item => {
        const itemMeta = metaItems.find(meta => meta.varId === item.variant_id.toString());
        return `${item.title} (Minimum: ${itemMeta.minQty}, Current: ${item.quantity})`;
      }).join('\n');
      
      throw new Error(`Some items do not meet the minimum quantity requirements:\n${itemsList}`);
    }

    // Prepare line items (volume discounts now handled natively by Shopify)
    const lineItems = cart.items.map(item => {
      const baseLineItem = {
        variantId: `gid://shopify/ProductVariant/${item.variant_id}`,
        quantity: item.quantity
      };

      // Add line item properties if they exist
      if (item.properties && Object.keys(item.properties).length > 0) {
        baseLineItem.customAttributes = Object.entries(item.properties).map(([key, value]) => ({
          key,
          value: String(value)
        }));
      }

      return baseLineItem;
    });

    // Create the request body with both line items and order discount
    const requestBody = {
      lineItems,
      appliedDiscount: {
        description: "Order Discount",
        value: 5,
        valueType: "PERCENTAGE",
        title: "INSTANT DISCOUNT 5% Off"
      }
    };

    // Updated fetch call with additional options
    const response = await fetch('https://order.promopunks.com.au/api/create-draft-order', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      credentials: 'include',
      mode: 'cors',
      body: JSON.stringify(requestBody)
    });

    // Add better error handling
    if (!response.ok) {
      const errorData = await response.json(); // Change from .text() to .json()
      console.error('Server response:', errorData);
      throw new Error(`Server error: ${errorData.error || response.status}`);
    }

    const draftOrder = await response.json();
    
    // Redirect to checkout
    if (draftOrder.invoiceUrl) {
      window.location.href = draftOrder.invoiceUrl;
    } else {
      throw new Error('No checkout URL in response');
    }

  } catch (error) {
    console.error('Error creating draft order:', error);
    // More detailed error message
    //alert(`Checkout error: ${error.message}. Please try again or contact support if the issue persists.`);
    alert(`${error.message}\nPlease adjust quantities before proceeding to checkout.`);
  } finally {
    hideLoading();
  }
}

// Hijack checkout buttons
function hijackCheckoutButtons() {
  // Cart form submit
  const cartForm = document.querySelector('form[action="/cart"]');
  if (cartForm) {
    cartForm.addEventListener('submit', function(e) {
      e.preventDefault();
      createDraftOrder();
    });
  }

  // Individual checkout buttons
  const checkoutButtons = document.querySelectorAll(
    '.checkout-buttonn'
  );
  
  checkoutButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      createDraftOrder();
    });
  });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', hijackCheckoutButtons);

// For dynamic cart updates
document.addEventListener('cart.rendered', hijackCheckoutButtons);

// Debug helper - logs minimum quantity requirements for cart items
function debugMinimumQuantities() {
  const metaItems = getCartMetaItems();
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      cart.items.forEach(item => {
        const itemMeta = metaItems.find(meta => meta.varId === item.variant_id.toString());
        console.log('Item:', item.title);
        console.log('Quantity:', item.quantity);
        console.log('Min Qty:', itemMeta?.minQty || 'none');
      });
    });
}